module.exports = __webpack_public_path__ + "img/close_session.1e8d2c48.svg";